import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { createPortal } from "react-dom";
import DetectedPauseCutoffPopup from "../../../DetectedPauseCutoffPopup";

const InfoPopupButton = () => {
  const [displayInfoPopup, setDisplayInfoPopup] = useState(false);

  return (
    <>
      <button
        className="speakingSectionPauseCutoffInfoButton"
        onClick={() => setDisplayInfoPopup(true)}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </button>
      {displayInfoPopup &&
        createPortal(
          <DetectedPauseCutoffPopup
            closePopup={() => setDisplayInfoPopup(false)}
          />,
          document.body
        )}
    </>
  );
};

export default InfoPopupButton;
